(()=>{
  const init=(root)=>{
    if(root.dataset.hwaReady)return;
    root.dataset.hwaReady='true';
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    const tabs=[...root.querySelectorAll('[data-stone]')];
    const panels=[...root.querySelectorAll('[data-stone-panel]')];
    const macro=root.querySelector('.hwa-macro');
    const descriptions=['golden citrine','soft green aventurine','deep green African turquoise'];
    const select=(index,focus=false)=>{
      tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
      panels.forEach((panel,i)=>{panel.hidden=i!==index;});
      macro.dataset.stoneView=String(index);
      macro.querySelector('.hwa-macro-index').textContent=`0${index+1} / 03`;
      macro.querySelector('img').alt=`Close-up of the ${descriptions[index]} beads in the Abundance bracelet`;
      if(focus)tabs[index].focus();
    };
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>select(index));
      tab.addEventListener('keydown',(event)=>{
        let next;
        if(event.key==='ArrowRight')next=(index+1)%tabs.length;
        if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
        if(event.key==='Home')next=0;
        if(event.key==='End')next=tabs.length-1;
        if(next!==undefined){event.preventDefault();select(next,true);}
      });
    });
    const reveals=[...root.querySelectorAll('[data-hwa-reveal]')];
    let revealObserver;
    if(!motion.matches&&'IntersectionObserver'in window){
      root.classList.add('hwa-motion');
      revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.remove('hwa-pending');revealObserver.unobserve(entry.target);}
      }),{threshold:0.08,rootMargin:'0px 0px -25px 0px'});
      reveals.forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('hwa-pending');revealObserver.observe(el);}});
    }
    const hero=root.querySelector('[data-hwa-parallax="hero"]');
    const film=root.querySelector('[data-hwa-parallax="film"]');
    let scheduled=false;
    const clamp=(v,min,max)=>Math.min(max,Math.max(min,v));
    const update=()=>{
      scheduled=false;
      if(!root.isConnected||motion.matches||document.hidden)return;
      const h=hero.getBoundingClientRect();
      if(h.bottom>0&&h.top<innerHeight){const t=clamp(-h.top/innerHeight,-.5,1);hero.style.setProperty('--hero-y',`${t*42}px`);hero.style.setProperty('--hero-r',`${-12+t*12}deg`);}
      const f=film.getBoundingClientRect();
      if(f.bottom>0&&f.top<innerHeight){const t=clamp((innerHeight-f.top)/(innerHeight*.85),0,1);film.style.setProperty('--film-margin',`${36*(1-t)}px`);film.style.setProperty('--film-radius',`${20*(1-t)}px`);film.style.setProperty('--film-scale',String(1.09-t*.09));}
    };
    const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update);}};
    const onMotion=()=>{root.classList.toggle('hwa-motion',!motion.matches);if(motion.matches)reveals.forEach(el=>el.classList.remove('hwa-pending'));schedule();};
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    window.addEventListener('pageshow',schedule);
    motion.addEventListener('change',onMotion);
    update();
    root.hwaCleanup=()=>{window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);window.removeEventListener('pageshow',schedule);motion.removeEventListener('change',onMotion);revealObserver?.disconnect();};
  };
  const boot=(scope=document)=>scope.querySelectorAll('[data-hwa]').forEach(init);
  boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-hwa]').forEach(root=>root.hwaCleanup?.()));
})();
